import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { DashboardAssigment } from '../entities/schema/dashboardassigment.entity';
import { Dashboard } from '../entities/schema/dashboard.entity';
import { Report } from '../entities/Reports/report.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class DashboardAssigmentService extends ODataEntityService<DashboardAssigment> {
  constructor(protected client: ODataClient) {
    super(client, 'DashboardAssigment', 'entities.schema.DashboardAssigment');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public dashboard(entity: EntityKey<DashboardAssigment>): ODataNavigationPropertyResource<Dashboard> {
    return this.entity(entity).navigationProperty<Dashboard>('dashboard');
  }
  public report(entity: EntityKey<DashboardAssigment>): ODataNavigationPropertyResource<Report> {
    return this.entity(entity).navigationProperty<Report>('report');
  }
  public status(entity: EntityKey<DashboardAssigment>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<DashboardAssigment>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
